import Beneficiarios from "../views/Beneficiarios";
import BoasVindas from "../views/BoasVindas";
import Confirmacao from "../views/Confirmacao";
import DadosCadastrais from "../views/DadosCadastrais";
import DadosCadastraisRespFinanceiro from "../views/DadosCadastraisRespFinanceiro";
import Documentos from "../views/Documentos";
import Parabens from "../views/Parabens";
import React from "react";
import StepWizard from "react-step-wizard";
import TipoParticipante from "../views/TipoParticipante";
import { navigationRef } from "../services/navigation";

function Routes() {
  return (
    <StepWizard ref={navigationRef}>
      <BoasVindas />
      <TipoParticipante />
      <DadosCadastrais />
      <DadosCadastraisRespFinanceiro />
      <Beneficiarios />
      <Documentos />
      <Confirmacao currentStep={navigationRef.currentStep} />
      <Parabens />
    </StepWizard>
  );
}
export default Routes;
